module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp13_8019.7fe79116.png";